import store from "@/redux/store";

import React, { useState } from "react";
import { useParams } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Overview } from "@/views/team/Overview";
import { loadUsers } from '@/reducers/User'
import { show } from '@/reducers/Modal'
import {BaseTimeLogView} from "@/views/logging/BaseTimeLog";
import { alert, info,success, error } from '@/reducers/Modal'
import { SAVE_TIME_REGISTRATIONS, hideRegistration } from '@/reducers/TimeRegistration'
import { TimeRegistrationPanel } from "@/views/logging/TimeRegistrationPanel";
import { checkAbility } from "@/Events/CheckAbilityEvent";
class LogController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
  }
  
    onSaveHandler = async (data) => {
        const { dispatch } = this.props;


     try {
        await dispatch(SAVE_TIME_REGISTRATIONS(data)).then((retData) => {
            if(!retData.error) {
                store.dispatch(hideRegistration());
                //this.props.navigate("/team/", {"replace": true});
            }
        })
        if(!this.props.error) {
            dispatch( alert({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
        }
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
        if(!this.props.error) {
            dispatch( success({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
       } 

      
    }
  
  render() {
      const {showTimeRegistration, key, users, customers, tenants, sectors, authUser, selected, worktype} = this.props;
      let userAbilities = store.getState()?.AuthReducer?.user_abilities;
      
      return (
          <>
          {checkAbility('timeregistration', 'create') &&
          <BaseTimeLogView {...this.props} key="timLogView" />
          }
          <TimeRegistrationPanel showTimeRegistration={showTimeRegistration} key={key} users={users} customers={customers} tenants={tenants} sectors={sectors} worktype={worktype} authUser={authUser} selected={selected} onSaveEvent={this.onSaveHandler}/>
          </>
      );
      
  }
}
const LogControllerInit = (props) => {
  return (
    <LogController 
      {...props} 
    />
  );
};

function mapStateToProps(state) {
    const {TimeRegistrationReducer, AuthReducer} = state;
    const {showTimeRegistration, key, users, customers, tenants, sectors, selected, worktype} = TimeRegistrationReducer;
    const {user_short} = AuthReducer;
  return {
    showTimeRegistration: showTimeRegistration,
    key: key,
    users, customers, tenants, sectors,worktype,
    authUser: user_short,
    selected: selected
    
  };
}

export default connect(mapStateToProps)(LogControllerInit);  